export const DEFAULT_PURCHASE_MONTHS = 12;

const toIsoDate = (date: Date): string => date.toISOString().slice(0, 10);

export const lastMonthsRange = (months: number): string => {
    const to = new Date();
    const from = new Date(to);
    from.setMonth(from.getMonth() - months);
    return `${toIsoDate(from)}|${toIsoDate(to)}`;
};

export const parseMonthsFromRange = (value: unknown): number | null => {
    if (typeof value !== 'string' || !value.includes('|')) return null;
    const [min, max] = value.split('|').map(raw => new Date(raw));
    if (Number.isNaN(min.getTime()) || Number.isNaN(max.getTime())) return null;
    const months = (max.getFullYear() - min.getFullYear()) * 12 + (max.getMonth() - min.getMonth());
    return months > 0 ? months : null;
};
